import { defineSlotRecipe } from '@chakra-ui/react'

export const stickyBanner = defineSlotRecipe({
  className: 'StickyBanner',
  slots: ['banner', 'container', 'crossIcon', 'message', 'messageWrapper', 'wrapper', 'icon'],
  base: {
    wrapper: {
      backgroundColor: 'bg.accent.subtle.default',
      '--layout-gutter': 'var(--alto-sem-space-xs)',
    },
    icon: {
      ml: 3,
      color: 'fg.accent.onSubtle',
    },
    message: {
      color: 'fg.accent.onSubtle',
      '& strong': {
        fontWeight: 'normal',
      },
      '& a': {
        textDecoration: 'underline',
        '& strong': {
          fontWeight: 'semibold',
        },
      },
    },
    crossIcon: {
      mr: 3,
    },
  },
  variants: {
    variant: {
      ERROR: {
        message: {
          color: 'fg.critical.onSubtle',
        },
        icon: {
          color: 'fg.critical.onSubtle',
        },
      },
      INFO: {
        message: {
          color: 'fg.information.primary',
        },
        icon: {
          color: 'fg.information.primary',
        },
      },
      SUCCESS: {
        message: {
          borderColor: 'brand.confirmationGreen',
        },
        icon: {
          color: 'fg.success.primary',
        },
      },
      WARNING: {
        message: {
          borderColor: 'brand.primary.red',
        },
        icon: {
          color: 'fg.warning.onSubtle',
        },
      },
    },
  },
})
